import React from 'react'
import { Body, Grid, PageSection } from '@superhi/design'

import { VideoWrapper } from './styles'

const CompanyName: React.FC<React.PropsWithChildren<unknown>> = () => (
  <PageSection title="What’s with the company name?" backgroundColor="yellow" headingLevel={2}>
    <Grid rowGap={{ small: 24, medium: 32 }}>
      <Grid.Cell span={{ small: 'full', medium: 'full', large: 6 }}>
        <Body level="2">
          No, it&rsquo;s not based on something illegal we&rsquo;ve been smoking. We pinky-promised
          our parents.
        </Body>
        <Body level="2">
          <span>
            We&rsquo;re named after a video on YouTube from 1994. A British TV show talking about
            this new thing that could access every picture ever painted and every word ever
            written... the information
          </span>
          <strong>superhi</strong>
          <span>ghway.</span>
        </Body>
        <Body level="2">
          We wanted to name ourselves after how creative the early internet was – no cookie cutter
          websites, no templates, everything made by hand, from scratch. Where things aren&rsquo;t
          always perfect but they&rsquo;re personal and real.
        </Body>
      </Grid.Cell>
      <Grid.Cell span={{ small: 'full', medium: 'full', large: 6 }}>
        <VideoWrapper>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/V8cnP-RtRHU"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </VideoWrapper>
      </Grid.Cell>
    </Grid>
  </PageSection>
)

export default CompanyName
